export const formatValue = (value: string | null | undefined, fallback = 'Unknown'): string => {
    if (!value || value.trim().length === 0) {
        return fallback
    }

    return value
}

export const formatListValue = (value: string[] | null | undefined, fallback = 'None'): string => {
    if (!value || value.length === 0) {
        return fallback
    }

    return value.join(', ')
}